import { Space } from "@/design-system/components/Space";
import { H5 } from "@/design-system/components/typography/UniTypography";
import { SxProp, View } from "dripsy";
import React, { ReactElement } from "react";

interface PageItemHeaderProps {
  title: string;
  suffix?: Array<ReactElement>;
  titleSuffix?: Array<ReactElement>;
  sx?: SxProp;
}

export const PageItemHeader: React.FC<PageItemHeaderProps> = (props) => {
  const { title, suffix, titleSuffix, sx } = props;

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <View sx={styles.title}>
        <H5 bold>{title}</H5>
        {titleSuffix && <View sx={styles.titleSuffix}>{titleSuffix}</View>}
      </View>
      {suffix && (
        <View sx={styles.suffix}>
          {suffix.map((item, index) => (
            <React.Fragment key={`page-item-header-${item}-${index}`}>
              {index > 0 && <Space width="$3" />}
              {item}
            </React.Fragment>
          ))}
        </View>
      )}
    </View>
  );
};

enum StyleName {
  container = "container",
  title = "title",
  titleSuffix = "titleSuffix",
  suffix = "suffix",
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    flexDirection: "row",
  },
  titleSuffix: {
    ml: "$4",
    flexDirection: "row",
  },
  suffix: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
};
